import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			category:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			memb_cat_for_selectedOption:{ value: 'company', label: 'Company'},
			memb_cat_for_selectedvalue:'company',
			description : '',		
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );

    }

	componentDidMount() {
	}

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'memb_cat_for'){
			this.setState({memb_cat_for_selectedOption:selOption})
			this.setState({memb_cat_for_selectedvalue : selOption.value});
		}
	};

	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});
	}
	onEditorChange(r, evt) {
		if(r == 'description'){
			const converted = this.emojiToEntity(evt);
			this.setState({ description: converted });
		}		
	}
	emojiToEntity(str) {
		return str.replace(/\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu, emoji => {
			return `&#${emoji.codePointAt(0)};`;
		});
	}
 
  
	handleSubmit = () => { 
		if(this.validateForm()){
			this.setState({Loading:true});
			const formdata = this.state;
			var qs = require('qs');
			var status = '';
			var memb_cat_for = '';

			if(formdata.selectedvalue === ''){
				status =formdata.selectedOption.value;
			}else{
				status = formdata.selectedvalue;
			}
			if(formdata.memb_cat_for_selectedvalue === ''){
				memb_cat_for = formdata.memb_cat_for_selectedOption.value;
			}else{
				memb_cat_for = formdata.memb_cat_for_selectedvalue;
			}

			var postObject ={
				admin_id: localStorage.getItem('admin_id'),
				category : formdata.category,
				status: status,
				memb_cat_for:memb_cat_for,
				categoryDesc: formdata.description,
			}
			//console.log(postObject,'-postObject');

			let formData = new FormData();
			for(let k in postObject) {
				formData.append(k, postObject[k]);
			}
			axios.post(apiUrl+"MembershipCategory/add",formData).then(res => {
				if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(function() {
						$('.success_message').html(this.props.navigate('/membershipcategory'));
					}.bind(this),3000);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(function() {
						$('.success_message').html('');
					}.bind(this),3000);
					this.setState({Loading:false});
				}
			});
		}
	}

	validateForm() {
		const {category} = this.state;
		const nameRegex = /^[A-Za-z\s.]+$/;
		let errors = {};
		let formIsValid = true;
		
		if (!category) {
			formIsValid = false;
			$('.errorcategory').html('<span class="errorspan">Please fill the field</span>');
		}else if(category){
			if (!nameRegex.test(category)) {
				formIsValid = false;
			$('.errorcategory').html('<span class="errorspan">Please enter the valid Category</span>');
			}else{
				$('.errorcategory').html('');
			}
			
		}	
		this.setState({
			errors: errors
		});
		return formIsValid;
	}

  	render() {
	const {selectedOption,memb_cat_for_selectedOption} = this.state;
    return (
      	<div className="wrapper"> 
 
			<Header />
			<MenuSidebar currentpage="MembershipCategory" currentTab="common" currentSubTab="membership-management" />  

			<div id="location-error"></div>
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div>
							<a class="primary-btn" href="/membershipcategory">Back</a>
						</div>
						<div className="title">
							<h4>Add Membership Category</h4>				
						</div>
						<form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">
										<label>Category Name<span class="required" style={{ color: "red" }} > * </span></label>
										<input type="text" name="category" onChange={this.handleInputChange} className="form-control" value={this.state.category}/>
										<div className="errorcategory"></div>
									</div>

									<div className="form-group">					
										<label>Category For<span class="required" style={{ color: "red" }} > * </span></label>
										<Select 
											name="memb_cat_for"
											value={memb_cat_for_selectedOption?memb_cat_for_selectedOption:{ value: 'company', label: 'Company'}}
											options={lang.common.memb_cat_for_option} 
											isSearchable = {false}
											onChange={this.handleChange.bind(this, 'memb_cat_for')}
										/>
									</div> 
								</div>
								
								<div className="form-right">
									<div className="form-group">					
										<label>Description</label>										
										<CKEditor
											editor={ClassicEditor}
											data={this.state.description || ''}
											onReady={(editor) => {
											// You can store the "editor" and use when it is needed.
											}}
											name="description"										
											onChange={(event, editor) => {
												const data = editor.getData();
												this.onEditorChange('description', data);
											}}
										/>
										<div className="errordescription"></div>
									</div>
									<div className="form-group">					
										<label>Status<span class="required" style={{ color: "red" }} > * </span></label>
										<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange.bind(this, 'status')}
										/>
									</div> 
								</div>	
							</div>		
							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?<span>Adding</span>:<span>Submit</span>}
								</button>
							</div>
						</form>
					</div>	
				</div>	
			</div>	
    	</div>
    );
  	}
}


export default (withRouter(Add));